moment.locale("ja", {
  weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
  weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
});

// 発送日が月曜日になる場合は前日の日・休を営業日としてカウントする条件（営業日日数で指定する）
const ahead_shipping_business_days = 2; // お急ぎ便を除外(デフォルト営業日が2以上で土曜日発送を可能とする)

BOLD.options.app.on('option_products_loaded', function() {
console.log('start blod option app on');
  if (!selector_delivery_way.length && !selector_delivery_express.length && !selector_delivery_day.length) {
    console.log('Custom Delivery Selector: Undefined');
    return;
  }

  if(!cart_express){ //カート１つ目商品が通常便の場合
    // クリックイベント設定（カート追加フォームサブミット時）
    $('form[id^="product-form-template--"] :button').on('click', function () {
      // バリデーションを行い、戻り値でフォーム送信を実行/キャンセルする
      return validateAddForm( $('form[id^="product-form-template--"]') );
    });

    // 休暇追加日数
    const holiday_add_days = getHolidayAdd();
    // 受取希望日のデフォルトをセット
    setDefaultDays(holiday_add_days);

    // お急ぎ便サービスの変更を監視
    for (var i = 0; i < selector_delivery_express.length; i++) {
      selector_delivery_express[i].addEventListener('change', function() {
        var value = this.value;
        // 配達方法の値を取得
        if (selector_delivery_way.length) {// 配達方法の指定ドロップダウンメニューがある場合
          var days = getDays(selector_delivery_way[0].value, value, delivery_min_days);
        } else {
          var days = getDays(delivery_shipping_label, value, delivery_min_days);
        }
        if (days){
          console.log('◆フォーム切り替え時のセット  \nお急ぎ便 : ' + selector_delivery_express[0].value);
          changeMinDelivery(days + holiday_add_days);
        }
      }, false);
    }

    // 配達方法の変更を監視
    // console.log('selector_delivery_way.length='+selector_delivery_way.length);
    for (var i = 0; i < selector_delivery_way.length; i++) {
      selector_delivery_way[i].addEventListener('change', function() {
        var value = this.value;
        // お急ぎ便の値を取得
        if (selector_delivery_express.length) {// お急ぎ便の指定ドロップダウンメニューがある場合
          var days = getDays(value, selector_delivery_express[0].value, delivery_min_days);
        } else {
          var days = getDays(value, '通常', delivery_min_days);
        }

    // console.log('days(selector_delivery_way.length)='+days);

        if (days){
          if (selector_delivery_express.length) {
            console.log('◆フォーム切り替え時のセット \nお急ぎ便 : ' + selector_delivery_express[0].value);
          } else {
            console.log('◆フォーム切り替え時のセット \nお急ぎ便 : 通常' );
          }
          changeMinDelivery(days + holiday_add_days);
        }
      }, false);
    }

    // 受取希望日の変更を監視
    selector_delivery_day[0].addEventListener('input', checkPastAndFutureDateAndHoliday, false);
  } else { //カート１つ目商品がお急ぎ便の場合
    console.log('カートにお急ぎ便設定あり');
  }

  // お急ぎ便対応表
  console.log('\n◆対応表のセットstart ');
  printExpressTable();

  if (disableDateFlag) {
    // console.log(targetdisableDateProducts);
    // 納期管理関係を表示しない
    // $('.bold_option_element select[name="properties[受取方法]"]').parents('.bold_option').css("display", "none");

    // $('.bold_option_element input[name="properties[受取希望日]"]').parents('.bold_option').css("display", "none");
    // $('.bold_option_element input[name="properties[受取希望日]"]').parents('label').children('.bold_option_title').text("対応できる最短着日以降*");

    // $('.bold_option_element select[name="properties[お急ぎ便]"]').parents('.bold_option').css("display", "none");
    // $('.bold_option_element select[name="properties[時間指定]"]').parents('.bold_option').css("display", "none");

    // return;
    console.log('要素を追加' + $('#express-table-notice').length);
    let noticeDisableDate = moment(targetdisableDateProducts.from).format("MM月DD日") + 'から' + moment(targetdisableDateProducts.to).format("MM月DD日");

    $('#express-table-notice').append('<p id="express-table-notice2"><sup>※2</sup> ' + noticeDisableDate + 'までの受け取りはできません。</p>');

    $('.bold_option_element input[name="properties[受取希望日]"]').parents('label').append('<sup> ※ ' + noticeDisableDate + 'までの受け取りはできません。</sup>')
  }

});// end BOLD.options.app.on

function setDefaultDays(holiday_add_days) {
// console.log('selector_delivery_way='+selector_delivery_way[0].value);
  // お急ぎ便の値をセット
  var selector_delivery_express_value = '';
  if (selector_delivery_express.length) {
      selector_delivery_express_value = selector_delivery_express[0].value;
  } else {// お急ぎ便選択フォームがない場合は全て通常
      selector_delivery_express_value = '通常';
  }
  // 配送までの日数を取得
  var days = getDays(selector_delivery_way[0].value, selector_delivery_express_value, delivery_min_days);

  if (selector_delivery_way.length) {// 配達方法の指定ドロップダウンメニューがある場合
    // 初期値
    var days = getDays(selector_delivery_way[0].value, selector_delivery_express_value, delivery_min_days);
  } else { // 配達方法の選択がない商品は全て `発送` 扱い
    // 初期値
    var days = getDays(delivery_shipping_label, selector_delivery_express_value, delivery_min_days);
  }

// console.log('selector_delivery_express_value='+selector_delivery_express_value);
// console.log('days='+days);

  // 初期値をセット
  if (days){
    console.log('◆初回フォームのセットstart\n');
    changeMinDelivery(days + holiday_add_days);
  }
}

// 日数を返す(判定できない場合はfalse)
function getDays(way, desire, delivery_min_days){
  // delivery:a・・・通常配送
  // delivery:b・・・お急ぎ配送
  // delivery:c・・・通常店頭受取
  // delivery:d・・・お急ぎ店頭受取
  // 配達方法、希望納期のどちらかが不明の場合はfalse

console.log('受け取り方法 = '+way);
console.log('お急ぎ便 = '+desire);
// console.log('delivery_min_days ='+JSON.stringify(delivery_min_days));

  if (!way || !desire) {
      return false;
  }
  if (way.match(/配送$/)) {// a or b
      if (desire.match(/^通常/)) {
          // a
          return delivery_min_days.a;
      }
      if (desire.match(/^利用しない/)) {
          // a
          return delivery_min_days.a;
      }
      if (desire.match(/^お急ぎ便/)) {
          // b
          return delivery_min_days.b;
      }
      if (desire.match(/^利用する/)) {
          // b
          return delivery_min_days.b;
      }
  }
  if (way.match(/^店頭受取/)) {// c or d
      if (desire.match(/^通常/)) {
          // c
          return delivery_min_days.c;
      }
      if (desire.match(/^利用しない/)) {
          // c
          return delivery_min_days.c;
      }
      if (desire.match(/^お急ぎ便/)) {
          // d
          return delivery_min_days.d;
      }
      if (desire.match(/^利用する/)) {
          // d
          return delivery_min_days.d;
      }
  }

  return false;
}

//  `days + 1` 日をプラスして `min` にセット
function changeMinDelivery(days, shipping = null, table =false){
  // days = 稼働日
  // 現在日付
  var now = moment();
  //var now = moment('2022-12-29 15:10:00');

  console.log('注文日時 = ' + now.format("YYYY-MM-DD H:mm ddd"));

  if (! isSunday(now) && !isHoliday(now)) {
    // 営業日：15時以降はプラス1日
    if (Number(now.format("H")) >= 15) {
      // 15時以降は翌日からカウントするのでプラス1日
      console.log('15時以降なのでプラス1営業日')
      days = ++days;
    }
    var target = now;
  } else {
    // 日曜日・休業日 は翌営業日まで時間をすすめる
    var next_business_day = now;
    while (isSunday(next_business_day) || isHoliday(next_business_day)) {
      next_business_day = now.add(1, "days");
    }
    console.log('翌営業日 = ' + next_business_day.format("YYYY-MM-DD ddd"));
    var target = next_business_day;
  }
//console.log('days = '+ days);
  // 追加日数分カウントアップする
  var i=0;
  var c=1;

  console.log('リードタイム = ' + days + '営業日')

  // 配送か店頭受取か
  if (shipping == null) {
    if (selector_delivery_way.length) {// 配達方法の指定ドロップダウンメニューがある場合
      if (selector_delivery_way[0].value.match(/^店頭受取/)) {
        shipping = false;
      } else {
        shipping = true;
      }
    }
  }

  while (c <= days) {
    // 現在日付に１日ずつプラス
    if (i === 0) {
      // 当日
      target = now;
    } else {
      // 翌日以降
      target = now.add(1, "days");
    }
    if (shipping && c === days && days > ahead_shipping_business_days) {
      // 配送の場合の最終営業日は日・祝をスキップしない
      console.log(c + '営業日');
      if (isSunday(target) || isHoliday(target)) {
        console.log('（発送日が月曜日になる場合は前日の日・休を営業日としてカウント）');
      }
      c++;
    }else if (!isSunday(target) && !isHoliday(target)) {
      // 日曜日・休業日以外のみカウントアップ
      console.log(c+'営業日');
      c++;
    }
    console.log(target.format("YYYY-MM-DD ddd"));
    i++;
  }

// console.log('target = ' + target.format("YYYY-MM-DD"));


  if (shipping) {
    // 配送に1日かかると仮定して1日プラス
    target = now.add(1, "days");
console.log('配送に1日かかると仮定して1日プラス');
console.log(target.format("YYYY-MM-DD ddd"));

  } // else if (isSunday(target) || isHoliday(target)) {
  //   // 店頭受取日が日曜日・休業日の場合は直前の営業日まで戻す
  //   while (isSunday(target) || isHoliday(target)){
  //     target = now.subtract(1, "days");
  //   }
  //   console.log('店頭受取日が日曜日・休業日の場合は直前の営業日まで戻す');
  //   console.log(target.format("YYYY-MM-DD ddd"));
  //       // do {
  //   //   target = now.add(1, "days");
  //   // } while (isSunday(target) || isHoliday(target));
  // }

  // 着日指定不可がセットされている場合
  if (disableDateFlag) {
    console.log('着日指定不可期間 = ' + targetdisableDateProducts.from + '~' + targetdisableDateProducts.to);
    // moment.jsのv2.13.0以降が必要
      if (target.isBetween(targetdisableDateProducts.from, targetdisableDateProducts.to, null, '[]')) {
        console.log('に含まれているので最短日を着日指定不可期間明けに変更する');
        target = moment(targetdisableDateProducts.to).add(1, "days");
        console.log('変更後の最短日 = ' + target.format("YYYY-MM-DD ddd"));
      }
  }

 // console.log('配送に1日かかると仮定して1日追加='+target.format("YYYY-MM-DD"));

  const nowSelected = moment($('input[name="properties[受取希望日]"]').val(), 'YYYY-MM-DD');
  // 予約商品などで「最短納期日付メタフィールド」(`_delivery_min_date`)が設定されている場合
  if(typeof deliveryMinDate != 'undefined') {
    // 受取希望日の `min`(target)より `_delivery_min_date` の方が後の場合、targetを `_delivery_min_date` で上書き
    if(moment(deliveryMinDate).diff(target, 'days') > 0) {
      target = moment(deliveryMinDate);
    }
  }

  // お急ぎ便対応テーブルの場合
  if (table) {
  // console.log('配送に1日かかると仮定して1日追加='+target.format("M月D日"));

    return target.format("M月D日");
  }

  // 選択済みの場合
  if ($('input[name="properties[受取希望日]"]').val()) {
      // 選択済みの日付が範囲外
      if (nowSelected.diff(target, 'days') < 0) {
          alert('受取希望日を改めて選択してください');
          $('input[name="properties[受取希望日]"]').focus();
      }
  }
  // 受取希望日の `min` と `max` をセット
  $('input[name="properties[受取希望日]"]').attr({"min" : target.format("YYYY-MM-DD"), "max" : moment().add(60, 'days').format("YYYY-MM-DD")});
  $('input[name="properties[受取希望日]"]').val(target.format("YYYY-MM-DD"));
}
// assets/holiday.jsonから休暇データを受け取って休暇期間中の特別追加日数を返す
function getHolidayAdd() {
  var result = 0;
  var now = moment();
  // holiday.json読み込み
  const holidayJson = $.getJSON({'url': holidayJsonUrl, 'async': false}).responseText;
  try {
      var holidayDatas = JSON.parse(holidayJson);
  } catch (error) {
      return result;
  }
  holidayDatas.some(function(str){
//        if (moment().isBetween(moment(str.start).startOf('days'), moment(str.end).endOf('days'))) {
      if (now >= moment(str.start).startOf('days') && now <= moment(str.end).endOf('days')) {
          // 範囲内なら result に add を代入
          result = str.add;
          return true;
      }
  });
  return result;
}
// 祝日の判定
function isHoliday(date) {

  // console.log('publicHolidayArray = ' + publicHolidayArray);
  // console.log('target = ' + moment(date).format("YYYY/M/D"));
  // console.log('boolean = ' + publicHolidayArray.includes(moment(date).format("YYYY/M/D")));

  return publicHolidayArray.includes(moment(date).format("YYYY/M/D"));
}

// 日曜日の判定
function isSunday(date) {
  // console.log('typeof date  = ' + typeof date);
  return date.day() === 0;
}

// 最短日以前選択時にアラートを出す
// 最短日に強制リセット
// 60日以降選択時にアラートを出す
// 60日に強制リセット
function checkPastAndFutureDateAndHoliday() {
  console.log('選択変更による再チェック');
  // 選択曜日
  var selectedDate = moment(this.value).day();
  // 祝日特別対応追加日
  var holiday_add_days = getHolidayAdd();
  // 受け取り方法の値をセット
  var selector_delivery_way_value = '';
  if (selector_delivery_way.length) {
    selector_delivery_way_value = selector_delivery_way[0].value;
  } else {// 受け取り方法の指定ドロップダウンメニューがない場合
    selector_delivery_way_value = delivery_shipping_label;
  }
  // お急ぎ便の値をセット
  var selector_delivery_express_value = '';
  if (selector_delivery_express.length) {
    selector_delivery_express_value = selector_delivery_express[0].value;
  } else {// お急ぎ便選択フォームがない場合は全て通常
    selector_delivery_express_value = '通常';
  }
  var days = getDays(selector_delivery_way_value, selector_delivery_express_value, delivery_min_days);
  days = days + holiday_add_days;


  console.log('選択日付 = '+ moment(this.value).format("YYYY-MM-DD ddd"));
  console.log('営業日 = '+ days);
  // 最短日より過去の日付のチェック
  // 現在日付
  var now = moment();

  if (! isSunday(now) && !isHoliday(now)) {
    // 営業日：15時以降はプラス1日
    if (Number(now.format("H")) >= 15) {
      // 15時以降は翌日からカウントするのでプラス1日
      days = ++days;
    }
    var target = now;
  } else {
    // 日曜日・休業日 は翌営業日まで時間をすすめる
    var next_business_day = now;
    while (isSunday(next_business_day) || isHoliday(next_business_day)) {
      next_business_day = now.add(1, "days");
    }
    var target = next_business_day;
  }

  // 追加日数分カウントアップする
  var i=0;
  var c=1;

  // 配送か店頭受取か
  var shipping = true;
  if (selector_delivery_way.length) {// 配達方法の指定ドロップダウンメニューがある場合
      if (selector_delivery_way[0].value.match(/^店頭受取/)) {
        shipping = false;
         console.log('店頭受取');
      }
  }

  while (c <= days) {
    // 現在日付に１日ずつプラス
    if (i === 0) {
      // 当日
      target = now;
    } else {
      // 翌日以降
      target = now.add(1, "days");
    }

    if (shipping && c === days && days > ahead_shipping_business_days) {
      // 配送の場合の最終営業日は日・祝をスキップしない
      c++;
    }else if (!isSunday(target) && !isHoliday(target)) {
      // 日曜日・休業日以外のみカウントアップ
      c++;
    }
    i++;
  }

  if (shipping) {
    // 配送に1日かかると仮定して1日追加
    target = now.add(1, "days");
    console.log('配送に1日かかると仮定して1日追加');
  }
  // 予約商品などで「最短納期日付メタフィールド」(`_delivery_min_date`)が設定されている場合
  if(typeof deliveryMinDate != 'undefined') {
    // 受取希望日の `min`(target)より `_delivery_min_date` の方が後の場合、targetを `_delivery_min_date` で上書き
    if(moment(deliveryMinDate).diff(target, 'days') > 0) {
      target = moment(deliveryMinDate);
    }
  }

  console.log('最短日 = '+target.format("YYYY-MM-DD ddd"));

  // 着日指定不可がセットされている場合は指定不可期間明けを最短日としてセット
  if (disableDateFlag) {
    console.log('着日指定不可期間 = ' + targetdisableDateProducts.from + '~' + targetdisableDateProducts.to);
    // moment.jsのv2.13.0以降が必要
      if (target.isBetween(targetdisableDateProducts.from, targetdisableDateProducts.to, null, '[]')) {
        console.log('に含まれているので最短日を着日指定不可期間明けに変更する');
        target = moment(targetdisableDateProducts.to).add(1, "days");
        console.log('変更後の最短日 = ' + target.format("YYYY-MM-DD ddd"));
      }
  }

  // 選択済みの場合
  if (this.value) {
    // 着日指定不可がセットされている場合
    if (disableDateFlag) {
      console.log('着日指定不可期間 = ' + targetdisableDateProducts.from + '~' + targetdisableDateProducts.to);
      // moment.jsのv2.13.0以降が必要
        if (moment(this.value).isBetween(targetdisableDateProducts.from, targetdisableDateProducts.to, null, '[]')) {
          alert(moment(targetdisableDateProducts.from).format("MM月DD日") +'から' + moment(targetdisableDateProducts.to).format("MM月DD日") + 'までの受け取りはできません');
          $('input[name="properties[受取希望日]"]').val(target.format("YYYY-MM-DD"));
          // フォーカスを外さないと再選択ができないので外す
          $('input[name="properties[受取希望日]"]').blur();
      return;
        }
    }
    // 選択済みの日付が範囲外
    // 最短日より前
    if (moment(this.value).diff(target.format('YYYY-MM-DD'), 'days') < 0) {
        $('input[name="properties[受取希望日]"]').val(target.format("YYYY-MM-DD"));
        // フォーカスを外さないと再選択ができないので外す
        $('input[name="properties[受取希望日]"]').blur();
        alert('最短日 '+target.format("YYYY-MM-DD")+'以降の日付を選択してください');
    return;
    }
    // 60日以降
    if (moment(this.value).diff(moment().add(60, 'days').format('YYYY-MM-DD'), 'days') > 0) {
        $('input[name="properties[受取希望日]"]').val(moment().add(60, 'days').format("YYYY-MM-DD"));
        // フォーカスを外さないと再選択ができないので外す
        $('input[name="properties[受取希望日]"]').blur();
        alert('選択できるのは60日先の日付（'+moment().add(60, 'days').format("YYYY-MM-DD")+'）までです');
    return;
    }
    // 「店頭受取」で選択済みの日付が日曜日・休業日
    if (! shipping && (isSunday(moment(this.value)) || isHoliday(moment(this.value)))) {
      $('input[name="properties[受取希望日]"]').val(target.format("YYYY-MM-DD"));
      // フォーカスを外さないと再選択ができないので外す
      $('input[name="properties[受取希望日]"]').blur();
      alert('店頭受取の場合、日曜日・休業日は指定できません');
    }
  }
  return;
}

// お急ぎ便対応票の表示
function printExpressTable() {
  if (selector_delivery_express.length && selector_delivery_way.length) {
console.log('\n◆◆配送 通常');
    let NormalDeliveryDate = changeMinDelivery(getDays('配送', '通常', delivery_min_days), true, true);
console.log('\n◆◆配送 お急ぎ便');
    let ExpressDeliveryDate = changeMinDelivery(getDays('配送', 'お急ぎ便', delivery_min_days), true, true);
console.log('\n◆◆店頭受取 通常');
    let NormalPickupDate = changeMinDelivery(getDays('店頭受取', '通常', delivery_min_days), false, true);
console.log('\n◆◆店頭受取 お急ぎ便');
    let ExpressPickupDate = changeMinDelivery(getDays('店頭受取', 'お急ぎ便', delivery_min_days), false, true);

    var express_table =  heredoc(`
    <div class="express">
      <span class="ss_text_box"><span>お急ぎ便対応商品</span>送料+2,200円（税込）</span>
    </div>
    <table class="table01 view_timer">
      <thead>
        <tr>
          <th></th>
          <th>配送 最短お届け日</th>
          <th>店頭受取 最短日</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>通常</th>
          <td label="配送 最短お届け日"><span class="time">{NormalDeliveryDate}</span><span class="no-wrap">以降</span></td>
          <td label="店頭受取 最短日"><span class="time">{NormalPickupDate}</span><span class="no-wrap">11:00以降</span></td>
        </tr>
        <tr>
          <th>お急ぎ便対応</th>
          <td label="配送 最短お届け日"><span class="time">{ExpressDeliveryDate}</span><span class="no-wrap">以降 <sub>※1</sub></span></td>
          <td label="店頭受取 最短日"><span class="time">{ExpressPickupDate}</span><span class="no-wrap">17:00以降</span></td>
        </tr>
      </tbody>
    </table>
    <p id="express-table-notice"><sup>※1</sup> 北海道、沖縄、四国、九州、中国、離島、和歌山県、青森県、秋田県は+1日以上頂きます。</p>
    ≪表記日時より早くお届けできる可能性もございます。お問合せ下さい≫
    `, {"NormalDeliveryDate":NormalDeliveryDate, "NormalPickupDate":NormalPickupDate, "ExpressDeliveryDate":ExpressDeliveryDate, "ExpressPickupDate":ExpressPickupDate});
  } else if (selector_delivery_express.length) {
console.log('\n◆◆配送 通常');
    let NormalDeliveryDate = changeMinDelivery(getDays('配送', '通常', delivery_min_days), true);
console.log('\n◆◆配送 お急ぎ便');
    let ExpressDeliveryDate = changeMinDelivery(getDays('配送', 'お急ぎ便', delivery_min_days), true);

    var express_table =  heredoc(`
    <div class="express">
      <span class="ss_text_box"><span>お急ぎ便対応商品</span>送料+2,200円（税込）</span>
    </div>
    <table class="table01 view_timer">
      <thead>
        <tr>
          <th></th>
          <th>配送 最短お届け日</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>通常</th>
          <td label="配送 最短お届け日"><span class="time">{NormalDeliveryDate}</span><span class="no-wrap">以降</span></td>
        </tr>
        <tr>
          <th>お急ぎ便対応</th>
          <td label="配送 最短お届け日"><span class="time">{ExpressDeliveryDate}</span><span class="no-wrap">以降</span> <sub>※1</sub></td>
        </tr>
      </tbody>
    </table>
    <p id="express-table-notice"><sup>※1</sup> 北海道、沖縄、四国、九州、中国、離島、和歌山県、青森県、秋田県は+1日以上頂きます。</p>
    ≪表記日時より早くお届けできる可能性もございます。お問合せ下さい≫
    `, {"NormalDeliveryDate":NormalDeliveryDate, "ExpressDeliveryDate":ExpressDeliveryDate});
  } else if (selector_delivery_way.length) {
console.log('\n◆◆配送 通常');
    let NormalDeliveryDate = changeMinDelivery(getDays('配送', '通常', delivery_min_days), true, true);
console.log('\n◆◆店頭受取 通常');
    let NormalPickupDate = changeMinDelivery(getDays('店頭受取', '通常', delivery_min_days), false, true);

  var express_table =  heredoc(`
  <table class="table01 view_timer">
    <thead>
      <tr>
        <th></th>
        <th>配送 最短お届け日</th>
        <th>店頭受取 最短日</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>通常</th>
        <td label="配送 最短お届け日"><span class="time">{NormalDeliveryDate}</span><span class="no-wrap">以降</span></td>
        <td label="店頭受取 最短日"><span class="time">{NormalPickupDate}</span><span class="no-wrap">11:00以降</span></td>
      </tr>
    </tbody>
  </table>
  <p id="express-table-notice"><sup>※1</sup> 北海道、沖縄、四国、九州、中国、離島、和歌山県、青森県、秋田県は+1日以上頂きます。</p>
  ≪表記日時より早くお届けできる可能性もございます。お問合せ下さい≫
  `, {"NormalDeliveryDate":NormalDeliveryDate, "NormalPickupDate":NormalPickupDate});
  } else {
console.log('\n◆◆配送 通常');
    let NormalDeliveryDate = changeMinDelivery(getDays('配送', '通常', delivery_min_days), true, true);

  var express_table =  heredoc(`
  <table class="table01 view_timer">
    <thead>
      <tr>
        <th></th>
        <th>配送 最短お届け日</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>通常</th>
        <td label="配送 最短お届け日"><span class="time">{NormalDeliveryDate}</span><span class="no-wrap">以降</span></td>
      </tr>
    </tbody>
  </table>
  <p id="express-table-notice"><sup>※1</sup> 北海道、沖縄、四国、九州、中国、離島、和歌山県、青森県、秋田県は+1日以上頂きます。</p>
  ≪表記日時より早くお届けできる可能性もございます。お問合せ下さい≫
  `, {"NormalDeliveryDate":NormalDeliveryDate});
//  return;
  }
  document.getElementById("express-table").innerHTML = express_table;
  document.getElementById("express-table2").innerHTML = express_table;
}

// ヒアドキュメントと置換
function heredoc(txt, dic){
  // 置換対象がなければ無視
  if(dic == null) return txt;

  Object.keys(dic).forEach(function (key) {
      txt = txt.replaceAll("{"+key+"}", dic[key]);
  });
  return txt;
}

/**
 * カートに追加フォームのバリデーション（フォームサブミット時に実行）
 * @param {*} addForm
 * @returns
 */
function validateAddForm(addForm) {
  // 一旦エラーメッセージを非表示
  // document.querySelectorAll('.bold_error_message').remove();
  addForm.find('.bold_error_message').remove();
  addForm.find('.bold_option').removeClass('bold_option_error');

  // パラメーターを取得
  let myParams = addForm.serializeArray();

  // 返り値・初期値（true:バリデーションOK、false:バリデーションNG）
  let resultValidation = true;

  let formShipping = false;
  let formDeliveryDate = null;

  // パラメーターから必要な値をセットしておく
  let specified_time;
  $.each(myParams, function(index, val){
    // console.log(val.name + ':' + val.value);
   if (val.name == 'properties[受取方法]' && val.value.match(/配送$/)) {
      formShipping = true;
    }

    if (val.name == 'properties[受取希望日]') {
      formDeliveryDate = val.value;
    }

    if (val.name == 'properties[時間指定]') {
      specified_time = val.value;
    } else if (val.name == 'properties[店頭受取の時間指定]') {
      specified_time = val.value;
    }

  });

  // バリデーション開始
  // エラーがあった場合に該当箇所へスクロールさせるために表示が先のものから順に処理すること

  // 店頭受取時の受け取り日付が日曜日・休業日の場合はエラーを返す
  if (! formShipping && formDeliveryDate && (isSunday(moment(formDeliveryDate)) || isHoliday(moment(formDeliveryDate)))) {
    let selectElm = selector_delivery_day[0].closest('div');
    selectElm.classList.add('bold_option_error');
    selectElm.insertAdjacentHTML('beforeend', '<span class="bold_error_message"><small>店頭受取の場合、日曜日・休業日は指定できません</small></span>');
    if (resultValidation) {
      // スクロール
      let rect = selectElm.getBoundingClientRect();
      let elemtop = rect.top + window.pageYOffset;
      document.documentElement.scrollTop = elemtop;
    }
    resultValidation = false;
  }

  /* 他のバリデーションをここに */
  //受取条件のチェック
  //base_receive,base_shipping_day, base_time @see sections/main-product.liquid
  let check_receive = [];
  if(base_shipping_day !== undefined && base_shipping_day !== formDeliveryDate){
    check_receive.push('受取希望日');
  }

  if(base_receive !== undefined && base_receive === '指定住所へ配送' &&  base_time !== specified_time){
    check_receive.push('時間指定');
  } else if(base_receive !== undefined && base_receive === '店頭受取(東京代官山)' &&  base_time !== specified_time){
    check_receive.push('店頭受取の時間指定');
  }

  if(check_receive.length > 0){
    let result = window.confirm(check_receive.join('と') + 'が違う商品がカートに入っています。続行しますか？続行の場合、各商品の希望日にご注意下さい。希望日を合わせたい場合はお問い合わせください。');
    if( !result ) {
      //console.log('キャンセルがクリックされました');
      resultValidation = false;
    }
  }
  // バリデーションここまで

  // バリデーション結果を返す
  return resultValidation;
}
